import { dnvRolesWithRestriction } from '@customer-portal/shared/constants/dnv-roles.constants';

export const isDnvUserHasRestrictedRole = (
  accessType?: string | null,
): boolean => {
  if (!accessType) return false;

  return (dnvRolesWithRestriction as string[]).includes(accessType);
};

export const shouldRestrictDnvUserFeatures = (
  accessType: string | null | undefined,
  coBrowsingUserEmail: string | null,
): boolean => {
  const isRestrictedRole = isDnvUserHasRestrictedRole(accessType);
  const isCoBrowsingSession = !!coBrowsingUserEmail;

  return isRestrictedRole && isCoBrowsingSession;
};
